<template>
  <v-card class="popup-root" v-resize="onResize">
    <motlet :options="motletOptions">
      <template v-slot:content="{ props }">
        <!-- eslint-disable-next-line prettier/prettier -->
      <field-selectable-grid
        :sstmId="props.motlet.descendant.systemId"
        :code="props.motlet.settings.grid.code"
        :event-code="props.motlet.settings.grid.eventCode"
        :selected="props.motlet.settings.grid.selectedFields"
        :height="height"
        :nodes="values.descendants"
        :timestamp="values.timestamp"
      />
      </template>
    </motlet>
  </v-card>
</template>

<script>
import FieldSelectableGrid from './FieldSelectableGrid';

export default {
  components: {
    FieldSelectableGrid,
  },
  data() {
    return {
      height: 150,
    };
  },
  computed: {
    opener() {
      return window.opener[this.$route.query.uuid];
    },
    values() {
      return this.opener?.$data?.values;
    },
    motletOptions() {
      return {
        id: this.$route.query.uuid,
        title: this.values.text,
        settings: { grid: { use: true, code: this.values.code, eventCode: this.values.eventCode } },
        descendant: {
          systemId: this.values.sstmId,
        },
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      const tbody = this.$el.querySelector('tbody');
      if (tbody && typeof MutationObserver !== 'undefined') {
        this._mo = new MutationObserver(this.scheduleFit);
        this._mo.observe(tbody, { childList: true });
      }
    });
  },
  beforeDestroy() {
    if (this._mo) this._mo.disconnect();
    clearTimeout(this._fitTimer);
    clearTimeout(this._resizeTimer);
  },
  methods: {
    onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this.height = window.innerHeight - 71;
      }, 50);
    },
    scheduleFit() {
      clearTimeout(this._fitTimer);
      this._fitTimer = setTimeout(this.fitPopupToGrid, 300);
    },
    fitPopupToGrid() {
      const wrapper = this.$el.querySelector('.v-data-table__wrapper');
      if (!wrapper) return;
      const overflowX = wrapper.scrollWidth - wrapper.clientWidth;
      if (overflowX > 5) {
        window.resizeTo(window.outerWidth + overflowX + 4, window.outerHeight);
      }
      if (this._mo) {
        this._mo.disconnect();
        this._mo = null;
      }
    },
  },
};
</script>

<style scoped>
.popup-root,
.popup-root >>> .card-wrap,
.popup-root >>> .box,
.popup-root >>> .v-card.pa-1.my-2,
.popup-root >>> .v-data-table,
.popup-root >>> .v-data-table > .v-data-table__wrapper {
  width: 100% !important;
}
.popup-root >>> .v-card.pa-1.my-2 {
  padding: 0 !important;
  margin: 0 !important;
}
.popup-root >>> .content-max-width {
  max-width: none !important;
}
</style>
